export const emptyFn = (): void => void 0;
